module.exports = __webpack_public_path__ + "static/day_with_timeslot_columns-e427cd039966bb7f89cb81ef0d4ca652.png";